import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TsSnackbarService } from 'tsui';

import { ApprovalsService } from './approvals.service';
import { Approval } from './approvals.types';

@Injectable({
  providedIn: 'root',
})
export class ApprovalsResolver {
  private approvalsService = inject(ApprovalsService);
  private router = inject(Router);
  private snackBar = inject(TsSnackbarService);

  resolve(route: ActivatedRouteSnapshot) {
    const approvalId = +route.paramMap.get('id');
    return this.approvalsService.getApprovalById(approvalId).pipe(
      catchError((error) => {
        if (error.status === 404) {
          this.snackBar.open('The requested approval cannot be found.', 'error');
        }
        this.router.navigate(['/']);
        return EMPTY;
      }),
    );
  }
}
